import React, {memo, useCallback, useEffect, useState, useRef} from 'react';
import {
  Button,
  Checkbox,
  Grid,
  Paper,
  TextField,
  Typography} from "@mui/material";
import {useFieldArray, useFormContext} from "react-hook-form";
import {useHistory} from "react-router-dom";
import {hasActiveUsers} from "../util/constant";
import FNOUsersCheckbox from "./FNOUsersCheckBox";
import websocketService from "../websocket/WebSocketService";
import FormControlLabel from '@mui/material/FormControlLabel';
import IOSSwitch from '../util/IOSSwitch'
const endpoint = `/algo-trading/api/fno/config`;

const FNOBuy = ({user, classes, setOpen, setWarningMessage, selectedIndex, clearOldMessages}) => {
  const history = useHistory();
  const {register, control} = useFormContext(); // retrieve all hook methods
  const {fields, replace} = useFieldArray({
    control,
    name: "config",
  });
  const shrinkProp = {shrink: true};
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [triggerStateMap, setTriggerStateMap] = useState(new Map());
  const triggerStateMapRef = useRef(triggerStateMap);

    // Keep ref always in sync (no re-render)
    useEffect(() => {
      triggerStateMapRef.current = triggerStateMap;
    }, [triggerStateMap]);

  useEffect(() => {
    websocketService.connect().then(r => {
        websocketService.subscribe('/fno/buy-trigger-state', message => {
            const { tradeStrategy, isTriggerOn } = JSON.parse(message?.body)
//             console.log(tradeStrategy, isTriggerOn)
            if (!tradeStrategy) {
                return
            }
            // Get current map from ref
            const currentMap = triggerStateMapRef.current;
            // Clone before update
            const updatedMap = new Map(currentMap);
            updatedMap.set(tradeStrategy, isTriggerOn);

            // Now update React state
            setTriggerStateMap(updatedMap);
      });
    })
  }, []);

  const fetchConfig = useCallback(() => {
    fetch(endpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': user.credential
        },
      }
    ).then(async (response) => {
      if (response.status === 401) {
        history.push('/')
        return
      }
      if (response.status >= 400) {
        response.text()
          .then(r => {
            console.error(r)
            setWarningMessage(r)
            setOpen(true)
          })
        return
      }
      const parse = JSON.parse(await response.text());
      replace(parse)
      setTriggerStateMap(new Map(parse.map(item => [item.name, item.triggered])));
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const takeImmediateTrade = (event) => {
    event.preventDefault()
    clearOldMessages()
    // Check for active users
    if (!hasActiveUsers(selectedUsers, setWarningMessage, setOpen)) {
      return;
    }

    if (!selectedIndex || selectedIndex === "") {
      setWarningMessage("Please select index")
      setOpen(true)
      return;
    }

    const activeUsersWithLots = Array.isArray(selectedUsers)
      ? selectedUsers.filter(u => u.active).map(u => ({ userId: u.userId, lots: u.lots || 1 }))
      : [];

    if (activeUsersWithLots.length === 0) {
        setWarningMessage("No active users selected.");
        setOpen(true);
        return;
    }

    console.log(event.target.value, activeUsersWithLots);
    fetch(`/algo-trading/api/fno/config/take-immediate-trade/${event.target.value}/${selectedIndex}`, {
      method: 'POST',
      headers: {
        'Authorization': user.credential,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(activeUsersWithLots)
    }).then(function (response) {
      response.text().then(r => {
        console.log(r);
        setWarningMessage(r)
        setOpen(true)
      })
    }, function (error) {
      console.log(error.message)
      setWarningMessage(error.message)
      setOpen(true)
    })
  }
  const takeTrade = (event) => {
    event.preventDefault()
    clearOldMessages()
    if (!hasActiveUsers(selectedUsers, setWarningMessage, setOpen)) {
      return;
    }
    if (!selectedIndex || selectedIndex === "") {
      setWarningMessage("Please select index")
      setOpen(true)
      return;
    }
    const activeUsersWithLots = Array.isArray(selectedUsers)
      ? selectedUsers.filter(u => u.active).map(u => ({ userId: u.userId, lots: u.lots || 1 }))
      : [];

    if (activeUsersWithLots.length === 0) {
        setWarningMessage("No active users selected.");
        setOpen(true);
        return;
    }
    console.log(event.target.value, activeUsersWithLots);
    fetch(`/algo-trading/api/fno/config/take-trade/${event.target.value}`, {
      method: 'POST',
      headers: {
        'Authorization': user.credential,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(activeUsersWithLots)
    }).then(function (response) {
      response.text().then(r => {
        console.log(r);
        setWarningMessage(r)
        setOpen(true)
      })
    }, function (error) {
      console.log(error.message)
      setWarningMessage(error.message)
      setOpen(true)
    })
  }
  const stopTrade = (event) => {
    event.preventDefault()
    clearOldMessages()
    if (!hasActiveUsers(selectedUsers, setWarningMessage, setOpen)) {
      return;
    }
    if (!selectedIndex || selectedIndex === "") {
      setWarningMessage("Please select index")
      setOpen(true)
      return;
    }

    console.log(event.target.value)

    fetch('/algo-trading/api/fno/config/stop-trade/' + event.target.value, {
      method: 'POST',
      headers: {
        'Authorization': user.credential,
        "Content-Type": "application/json",
      }
    }).then(function (response) {
      response.text().then(r => {
        console.log(r);
        setWarningMessage(r)
        setOpen(true)
      })
    }, function (error) {
      console.log(error.message)
      setWarningMessage(error.message)
      setOpen(true)
    })
  }

  function getControlComponent(index, d, mode) {
      function getTriggerName(manual_strategy_name) {
          switch(manual_strategy_name){
              case "FNO_SLM_MANUAL_BULLISH": return "FNO_SLM_TR_BULLISH";
              case "FNO_SLM_MANUAL_BULLISH_5_MINS": return "FNO_SLM_TR_BULLISH_5_MINS";
              case "FNO_SLM_MANUAL_BEARISH": return "FNO_SLM_TR_BEARISH";
              case "FNO_SLM_MANUAL_BEARISH_5_MINS": return "FNO_SLM_TR_BEARISH_5_MINS";
              default: return manual_strategy_name;
              }
          }
    if (d?.displayName?.includes(mode)) {
      return (
        <Grid container item key={index} justifyContent={"centre"} xs={12} md={12} spacing={2} my={0.5}>
          <Grid item xs={6} md={3}>
            <Typography variant="inherit" fontSize={20} gutterBottom>{getDisplayName(d)}
            <FormControlLabel
                  control={<IOSSwitch sx={{ m: 1 }} checked={!!triggerStateMap?.get(getTriggerName(d?.name))} />}
                  label=""
                />
            </Typography>
          </Grid>
          <Grid item xs={1} md={1}>
            <Checkbox color={getColor(mode)} defaultChecked={d?.enabled}
                      name="Enabled" {...register(`config.${index}.enabled`)} />
          </Grid>
          <Grid item>
            <Button variant="contained" size="small" color={getColor(mode)} value={getTriggerName(d?.name)}
                    onClick={takeTrade} style={{fontSize: '0.85rem'}}>Trigger</Button>
          </Grid>
          <Grid item>
            <Button variant="contained" size="small" color={getColor(mode)} value={getTriggerName(d?.name)}
                    onClick={stopTrade} style={{fontSize: '0.85rem'}}>Cancel TR</Button>
          </Grid>
          {(d?.name?.includes("MANUAL")) && <Grid item>
            <Button variant="contained" size="small" color={getColor(mode)} value={d?.name}
                    onClick={takeImmediateTrade} style={{fontSize: '0.85rem'}}>{getActionName(d)}</Button>
          </Grid>}
          {(!d?.name?.includes("MANUAL")) && <Grid item>
            &nbsp;
          </Grid>}
        </Grid>)
    }
    ;
  }

  const getColor = (mode) => {
    return mode === 'Bullish' ? "primary" : "secondary";
  }

  function getDisplayName(d) {
    return d?.displayName
      ?.replaceAll("FNO", "")
      ?.replaceAll("Bearish", "")
      ?.replaceAll("Bullish", "")
      ?.replaceAll("Buy", "");
  }

  function getActionName(d) {
    return d?.displayName?.toUpperCase()?.includes("BUY") ? "Buy Now" : "Sell Now";
  }

  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  return (
    <Grid item container xs={12} md={12} spacing={2}>
      <Grid item xs={12} md={6} lg={12}>
        <Paper elevation={1} sx={{padding: 1}}>
          <Grid item>
            <FNOUsersCheckbox user={user}
                      selectedUsers={selectedUsers}
                      setSelectedUsers={setSelectedUsers}
                      allUsers={allUsers}
                      setAllUsers={setAllUsers}
                      setErrorMessag={setWarningMessage}
                      type={"BUY"}
            />
          </Grid>
        </Paper>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        <Paper elevation={1} sx={{padding: 2}}>
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={12} md={12} lg={6}>
              <Typography variant="h6" gutterBottom>Bearish Buy</Typography>
              {fields
                ?.filter(d => !d?.name?.includes("FNO_SLM_TR"))
                ?.map((d, index) => getControlComponent(index, d, "Bearish"))}
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
              <Typography variant="h6" gutterBottom>Bullish Buy</Typography>
              {fields
                ?.filter(d => !d?.name?.includes("FNO_SLM_TR"))
                ?.map((d, index) => getControlComponent(index, d, "Bullish"))}
            </Grid>
            <Grid item xs={12}>
              <Button variant="contained" type="submit">Save</Button>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default memo(FNOBuy);